import { connect } from "react-redux";
import ConfirmationModal from "./ConfirmationModal";
import { hideModal } from "./action-modal";

export default connect(null, { hideModal })(ConfirmationModal);
